import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ContentManager from '../../components/admin/ContentManager';

export default function BannersPage() {
  return (
    <AdminLayout>
      <ContentManager
        title="Banners Management"
        subtitle="Manage homepage hero slider banners (Desktop & Mobile images)"
        contentType="banners"
        fields={[
          { name: 'title', label: 'Banner Title', type: 'text', required: true },
          { name: 'subtitle', label: 'Subtitle', type: 'text' },
          
          // Desktop Image - Upload or URL
          { name: 'desktop_image_file', label: 'Desktop Image Upload (1920x500)', type: 'file', fileType: 'image', hint: 'Upload banner image for desktop (recommended: 1920x500px)' },
          { name: 'image_url', label: 'OR Desktop Image URL', type: 'text', placeholder: 'https://... or /images/banner.jpg (if not uploading file)' },
          
          // Mobile Image - Upload or URL
          { name: 'mobile_image_file', label: 'Mobile Image Upload (768x400)', type: 'file', fileType: 'image', hint: 'Upload banner image for mobile (recommended: 768x400px)' },
          { name: 'mobile_image_url', label: 'OR Mobile Image URL', type: 'text', placeholder: 'https://... or leave empty to use desktop image' },
          
          { name: 'link_url', label: 'Link URL (Click destination)', type: 'text', placeholder: 'https://example.com or /about' },
          { name: 'alt_text', label: 'Alt Text (Accessibility)', type: 'text' },
          { name: 'priority', label: 'Priority (Higher = First)', type: 'number', defaultValue: 10 },
          { name: 'is_active', label: 'Active', type: 'checkbox', defaultValue: true },
          { name: 'is_published', label: 'Published', type: 'checkbox', defaultValue: true },
        ]}
        columns={['title', 'priority', 'is_active', 'is_published']}
      />
    </AdminLayout>
  );
}
